/** No-op function. Returns `null` to satisfy most React typings. */
export default function noop() {
  return null
}
